import { render, staticRenderFns } from "./CustomerInvoice.vue?vue&type=template&id=3110613b"
import script from "./CustomerInvoice.vue?vue&type=script&lang=js"
export * from "./CustomerInvoice.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoice.vue?vue&type=style&index=0&id=3110613b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports